import { render } from "./ChildENComponent.vue?vue&type=template&id=35e818a6&scoped=true"
import script from "./ChildENComponent.vue?vue&type=script&lang=js"
export * from "./ChildENComponent.vue?vue&type=script&lang=js"

import "./ChildENComponent.vue?vue&type=style&index=0&id=35e818a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e818a6"]])

export default __exports__